import React from "react";
import { Alert, AlertDescription, AlertTitle } from "./ui/alert";
import { Button } from "./ui/button";

function FeatureFailure({ onRetry }) {
  return (
    <Alert className="border-warning/40 bg-warning/10" data-testid="feature-error-fallback">
      <AlertTitle>This page could not be displayed</AlertTitle>
      <AlertDescription className="mt-2 flex flex-col items-start gap-3">
        <span>The application shell is still available. Try opening this page again.</span>
        <Button
          type="button"
          variant="retry"
          onClick={onRetry}
          data-action-category="retry-refresh"
          data-testid="feature-error-retry"
        >
          Retry
        </Button>
      </AlertDescription>
    </Alert>
  );
}

export function BackendUnavailableNotice({ retrying, onRetry }) {
  return (
    <Alert
      className="mb-6 border-warning/40 bg-warning/10"
      data-testid="backend-unavailable-notice"
    >
      <AlertTitle>Backend unavailable</AlertTitle>
      <AlertDescription className="mt-2 flex flex-col items-start gap-3">
        <span>Flowpi is reconnecting. You can keep using the navigation while it retries.</span>
        <Button
          type="button"
          variant="retry"
          onClick={onRetry}
          disabled={retrying}
          data-action-category="retry-refresh"
          data-testid="backend-health-retry"
        >
          {retrying ? "Retrying..." : "Retry"}
        </Button>
      </AlertDescription>
    </Alert>
  );
}

export default class FeatureErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidUpdate(previousProps) {
    if (this.state.failed && previousProps.resetKey !== this.props.resetKey) {
      this.setState({ failed: false });
    }
  }

  retry = () => {
    this.setState({ failed: false });
  };

  render() {
    if (this.state.failed) return <FeatureFailure onRetry={this.retry} />;
    return this.props.children;
  }
}
